import { router } from "@inertiajs/react"

// Keep in sync with AnalyticsPathPolicy::PRIVATE_PATH_PREFIXES.
const PRIVATE_PATH_PREFIXES = [
  "/admin",
  "/app",
  "/educator",
  "/settings",
  "/sign_in",
  "/sign_up",
  "/sign_out",
  "/confirmation",
  "/kriya",
  "/auth",
  "/sessions",
  "/api",
  "/telemetry",
  "/letter_opener",
] as const

export function isPublicAnalyticsPath(path: string): boolean {
  return !PRIVATE_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  )
}

export function crossesAnalyticsBoundary(
  currentPath: string,
  destinationPath: string,
): boolean {
  return (
    isPublicAnalyticsPath(currentPath) !==
    isPublicAnalyticsPath(destinationPath)
  )
}

export function initializeGoogleAnalytics() {
  router.on("before", (event) => {
    const visit = event.detail.visit
    const destination = visit.url

    // Mutating requests must finish normally; their eventual redirect GET is
    // converted to a document request by the Rails fallback when necessary.
    if (visit.method !== "get") return
    if (destination.origin !== window.location.origin) return
    if (
      !crossesAnalyticsBoundary(window.location.pathname, destination.pathname)
    ) {
      return
    }

    // Do not prefetch content across the analytics boundary. On an actual
    // visit, replace Inertia's XHR with a document request so the Rails layout
    // can add or remove the Google tag for the destination.
    if (!visit.prefetch) window.location.assign(destination.href)

    return false
  })
}
